import { Component } from '@angular/core';
import { TcPage } from '@tc/core';

@Component({
  selector: 'app-login-oauth-page',
  templateUrl: './login-oauth-page.component.html',
  styleUrls: ['./login-oauth-page.component.scss'],
})
export class LoginOauthPageComponent extends TcPage {
  constructor() {
    super();
  }
}
